module.exports = __webpack_public_path__ + "static/apple-icon-180x180-5fd6ac030cc008362ec70329fce9d006.png";